"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIXTURE_RESUME = void 0;
/**
 * CV fictif de référence (fixture)
 * Utilisé pour :
 * - Preview BO (aperçu des thèmes)
 * - Tests unitaires (rendu de chaque thème)
 * - Démo en cabine
 *
 * Contenu en français pour valider les accents et les sections longues.
 */
exports.FIXTURE_RESUME = {
    basics: {
        name: 'Marie Dupont',
        label: 'Responsable Administrative',
        email: 'marie.dupont@email.com',
        phone: '06 12 34 56 78',
        summary: "Administratrice expérimentée avec plus de 8 ans d'expérience en gestion administrative, comptabilité et management d'équipe. Reconnue pour ma rigueur, mon organisation et ma capacité à optimiser les processus internes.",
        location: {
            city: 'Lyon',
            region: 'Auvergne-Rhône-Alpes',
            countryCode: 'FR',
        },
    },
    work: [
        {
            name: 'Assistante de direction',
            position: 'Assistante de direction',
            company: 'Groupe Leroy SA',
            location: 'Lyon, France',
            startDate: '2021-03',
            endDate: '2024-12',
            summary: 'Gestion administrative complète de la direction générale',
            highlights: [
                "Coordination de l'agenda de 3 cadres-dirigeants",
                'Organisation de déplacements professionnels nationaux et internationaux',
                'Rédaction de courriers, comptes-rendus et notes de synthèse',
                "Mise en place d'un système de classement numérique ayant réduit le temps de recherche de 40%",
                'Gestion des fournisseurs et suivi des commandes',
            ],
        },
        {
            name: 'Chargée de bureau',
            position: 'Chargée de bureau',
            company: 'Cabinet Martin & Associés',
            location: 'Villeurbanne, France',
            startDate: '2018-09',
            endDate: '2021-02',
            summary: "Accueil et gestion administrative d'un cabinet de conseil",
            highlights: [
                'Accueil physique et téléphonique de la clientèle',
                'Gestion de la comptabilité fournisseurs et facturation',
                "Organisation de réunions et événements d'équipe",
                'Suivi des dossiers clients et relances',
                'Formation de 2新入 staff aux procédures internes',
            ],
        },
    ],
    education: [
        {
            institution: 'Université Lumière Lyon 2',
            area: 'Administration générale',
            studyType: 'Licence',
            startDate: '2015-09',
            endDate: '2018-06',
        },
    ],
    skills: [
        {
            name: 'Microsoft Office',
            level: 'Expert',
            keywords: ['Excel', 'Word', 'PowerPoint', 'Outlook'],
        },
        {
            name: 'Comptabilité',
            level: 'Confirmé',
            keywords: ['Sage', 'facturation', 'trésorerie'],
        },
        {
            name: 'Gestion de projet',
            level: 'Confirmé',
        },
        {
            name: 'Communication',
            level: 'Avancé',
        },
        {
            name: 'Anglais professionnel',
            level: 'Intermédiaire',
        },
    ],
    languages: [
        {
            language: 'Français',
            fluency: 'Langue maternelle',
        },
        {
            language: 'Anglais',
            fluency: 'Professionnel (B2)',
        },
    ],
    interests: [
        {
            name: 'Randonnée',
            keywords: ['montagne', 'sentiers'],
        },
    ],
};
